<template>
  <div class="suporte">
    <img src="@/assets/images/logo.png" alt="" />
    <h2>Suporte eSUS Feedback</h2>
    <div id="info" style="display: none"></div>
  </div>
</template>

<script>
var md5 = require('js-md5')

export default {
  name: 'Suporte',
  metaInfo: {
    title: 'eSUS Feedback - Suporte',
    titleTemplate: null,
  },
  mounted() {
    const pluginExists = this.isMyScriptLoaded(
      'https://cdn.bitrix24.com.br/b22433349/crm/site_button/loader_4_1lnv7k.js'
    )

    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      'https://cdn.bitrix24.com.br/b22433349/crm/site_button/loader_4_1lnv7k.js'
    )
    plugin.async = true
    if (!pluginExists) {
      document.head.appendChild(plugin)
    }

    window.addEventListener('onBitrixLiveChat', function (event) {
      var widget = event.detail.widget

      let uuid = ''
      let municipio = ''
      let formatedName = ''
      let funcao = ''
      let name = ''
      let lastName = ''
      let email = ''
      let telefone = ''

      if (document.getElementById('info').innerText != '') {
        // Captura a informação enviada via postMessage do app
        const data = document.getElementById('info').innerText.split(',')
        uuid = data[0]
        municipio = data[1]
        formatedName = data[2].split(' ')
        funcao = data[3]
        name = formatedName[0]
        if (formatedName.length > 1) {
          lastName = formatedName[1]
        }
        email = data[4]
        telefone = data[5]

        const uuid_secret = '8b13e5bf-f1f3-47d5-ac3b-f8f4f35c4ac5'
        const site = location.hostname
        const id = uuid

        const hash = md5(id + site + uuid_secret)

        // Identificação da autorização externa do usuário
        widget.setUserRegisterData({
          hash: hash,
          name: name,
          lastName: lastName,
          avatar: '',
          email: '',
          www: location.hostname,
        })

        // Identificação das informações adicionais (formato alargado; publicado no início de uma nova sessão)
        widget.setCustomData([
          {
            USER: {
              NAME: `${name} ${lastName}`,
              AVATAR: '',
            },
          },
          {
            GRID: [
              {
                NAME: 'Município',
                VALUE: municipio,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Função',
                VALUE: funcao,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'E-mail',
                VALUE: email,
                DISPLAY: 'LINE',
              },
              {
                NAME: 'Telefone',
                VALUE: telefone,
                DISPLAY: 'LINE',
              },
            ],
          },
        ])
      }

      // widget.open()

      // o widget foi aberto
      widget.subscribe({
        type: BX.LiveChatWidget.SubscriptionType.widgetOpen,
        callback: function (data) {
          window.postMessage('open', '*')
        },
      })

      // o widget foi fechado
      widget.subscribe({
        type: BX.LiveChatWidget.SubscriptionType.widgetClose,
        callback: function (data) {
          window.postMessage('fechar', '*')
        },
      })

      // o operador enviou uma mensagem
      widget.subscribe({
        type: BX.LiveChatWidget.SubscriptionType.operatorMessage,
        callback: function (data) {
          window.postMessage('nova-mensagem', '*')
        },
      })
    })
  },
  methods: {
    isMyScriptLoaded(url) {
      var scripts = document.getElementsByTagName('script')
      for (var i = scripts.length; i--; ) {
        if (scripts[i].src == url) return true
      }
      return false
    },
  },
}
</script>

<style lang="scss">
.suporte {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  gap: 10px;
  h2 {
    text-align: center;
  }
  @media screen and (max-width: 656px) {
    h2 {
      font-size: 14px;
    }
    img {
      width: 80px;
    }
  }
}
.bx-livechat-show {
  height: 100vh !important;
  width: 100vw !important;
  bottom: 0 !important;
  right: 0 !important;
  left: 0px !important;
}
@media screen and (max-width: 656px) {
  .b24-widget-button-position-bottom-right {
    right: 10px !important;
  }
  .bx-livechat-position-bottom-right {
    right: 0 !important;
  }
}
</style>
